import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { Modal }            from 'react-bootstrap';
import TopoPag              from '../../../container/RenderTopoPag';
import BatalhaAbertos       from './batalha_abertos';
import BatalhaConcluidos    from './batalha_concluidos';
import BatalhaConvidar      from './batalha_convidar';
import BatalhaConvidarOponente      from './batalha_convidar_oponente';
import { GetActionBg }      from '../../../actions/scopoAction';
import bg_batalha           from "../../../img/bg/bg_batalha.png";
import '../../../css/aluno/batalha/batalha.css';
import '../../../css/aluno/batalha/batalha-match.css';

class Batalha extends Component {

    constructor(props){
        super(props);
        this.state = {
            showModal:false}
    }

    open(){
      this.setState({showModal:true});
    }
  
    close(){
       this.setState({showModal:false});
    }

    componentWillMount(){
      this.props.GetActionBg(bg_batalha);
    }

    componentWillReceiveProps(nextProps){
        if(nextProps.actionModal){
           this.setState({showModal: true });
        }else{
           this.setState({showModal: false });
        }
    }

    render() {
        return (
            <div className="hud-middle-center active">
                <TopoPag 
                    // menu1="BATALHA INDIVIDUAL"
                    // menu2="BATALHA COLETIVA" 
                    titulo="BATALHA"
                 />
                <main className="hud-middle-center-content">
                    <div className="battle">
                    <div className="battle-card-matches">
                            <BatalhaAbertos/>
                            <div className="battle-action">
                                <div className="battle-action-inline">
                                    <a href="javascript:void(0)" className="action action-fluid action-icon action-simple">
                                        <i className="gamefica-icon gamefica-double-angle-left primary"></i>
                                    </a>
                                    <a href="javascript:void(0)" className="action action-fluid action-icon action-simple">
                                        <i className="gamefica-icon gamefica-double-angle-right primary"></i>
                                    </a>
                                </div>
                                {/* <a href="javascript:void(0)" className="action action-fluid">Cadastrar Questão</a> */}
                                {/* <a href="javascript:void(0)" className="action action-fluid">Grupo de batalha</a> */}
                            </div>
                            <BatalhaConcluidos/>
                        </div>
                        <BatalhaConvidar/>
                    </div>
                </main>
                <Modal show={this.state.showModal}  bsSize="lg">
                      <BatalhaConvidarOponente/>
                </Modal>
            </div>  
        );
    }
}

function mapStateToProps(state) {

    return { 
            session     : state.auth.session,
            actionModal : state.scopoReducer.actionModal,
            menu        : state.configReducer.menu,
           }
}

export default connect(mapStateToProps, { GetActionBg })(Batalha);



// WEBPACK FOOTER //
// ./src/components/aluno/batalha/batalha.js